<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">Length</label>
            <div class="col-md-2">
                <div class="form-control">{{propertyDescription.length}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Width</label>
            <div class="col-md-2">
                <div class="form-control">{{propertyDescription.width}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Area</label>
            <div class="col-md-2">
                <div class="form-control">{{propertyDescription.area}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Boundary estimates based on</label>
            <div class="col-md-10">
                <div class="row well">
                    <div v-for="boundaryType in boundaryTypeSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="boundaryType.boundaryTypeId">
                        <label>{{boundaryType.description}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import propertyDescriptionService from '../../services/siteForm/propertyDescriptionService'

export default {
    name: 'propertyDescriptionForm',
    components: {
    },
    props: ['crrId'],
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            boundaryTypeSelectedList: [],
            propertyDescription: {}
        }
    },
    mounted () {
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'InvestigativeHistoryForm', message)
        },
        loadPropertyBoundaries () {
            this.log('load property boundary')
            var searchDto = {propertyDescriptionId: this.propertyDescription.propertyDescriptionId}
            return propertyDescriptionService.searchPropertyBoundary(this.$http, searchDto).then(result => {
                this.boundaryTypeSelectedList = propertyDescriptionService.getBoundaryTypeList().filter(boundaryType => {
                    return result.data.some(x => x.boundaryTypeId === boundaryType.boundaryTypeId)
                })
                return result
            })
        },
        loadData () {
            this.log('Loading Data for crrId: ' + this.crrId)
            //return Promise.resolve(1)
            return propertyDescriptionService.searchPropertyDescription(this.$http, {culturalResourceRecordingId: this.crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.propertyDescription = response.data[0]
                    Promise.all([
                        this.loadPropertyBoundaries()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('no reponse found')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// PropertyDescription.vue?c73c76c4